<template>
  <div class="dashboard-root Main-section">
    <v-navigation-drawer
      v-model="drawer"
      :permanent="!$vuetify.breakpoint.smAndDown"
      width="260"
      app
      class="app-sidebar"
    >
      <div class="app-sidebar__brand">
        <img src="/scrapingant-logo.png" alt="" class="app-sidebar__logo" />
        <span class="app-sidebar__wordmark">ScrapingAnt</span>
      </div>

      <v-list class="app-sidebar__list pa-0" nav>
        <v-list-item
          v-for="item in primaryNav"
          :key="item.to"
          :to="item.to"
          class="app-sidebar__item"
          link
        >
          <v-list-item-icon class="app-sidebar__icon">
            <img
              v-if="item.image"
              :src="item.image"
              width="22"
              height="22"
              alt=""
            />
            <v-icon v-else>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div class="app-sidebar__footer">
        <v-list class="app-sidebar__list pa-0" nav>
          <v-list-item
            class="app-sidebar__item"
            link
            @click="open_documentation"
          >
            <v-list-item-icon class="app-sidebar__icon">
              <v-icon>mdi-book-open-variant-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>API Docs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="app-sidebar__item"
            link
            @click="open_proxies_documentation"
          >
            <v-list-item-icon class="app-sidebar__icon">
              <v-icon>mdi-book-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Proxies Docs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="app-sidebar__item"
            link
            href="mailto:support@scrapingant.com"
          >
            <v-list-item-icon class="app-sidebar__icon">
              <v-icon>mdi-lifebuoy</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Contact support</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="app-sidebar__divider"></div>

        <v-menu
          offset-y
          top
          right
          min-width="220"
          nudge-top="8"
          content-class="app-sidebar__menu-content"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="app-sidebar__user"
              v-bind="attrs"
              v-on="on"
            >
              <v-avatar size="32" color="primary">
                <span class="app-sidebar__user-initial">{{
                  avatarInitial
                }}</span>
              </v-avatar>
              <span class="app-sidebar__user-email" :title="user_email">{{
                user_email || "…"
              }}</span>
              <v-icon size="18" class="app-sidebar__user-chevron"
                >mdi-chevron-up</v-icon
              >
            </button>
          </template>

          <v-list dense class="app-sidebar__menu">
            <v-list-item :to="{ name: 'Profile' }">
              <v-list-item-icon class="mr-3">
                <v-icon small>mdi-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Profile</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="logout">
              <v-list-item-icon class="mr-3">
                <v-icon small color="error">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="error--text">Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-navigation-drawer>

    <v-app-bar
      v-if="$vuetify.breakpoint.smAndDown"
      app
      height="56"
      color="white"
      class="app-topbar-mobile"
      flat
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <div class="app-topbar-mobile__brand">
        <img src="/scrapingant-logo.png" alt="" />
        <span>ScrapingAnt</span>
      </div>
    </v-app-bar>

    <div class="page-wrapper">
      <dashboard-content></dashboard-content>
    </div>
  </div>
</template>

<script>
import DashboardContent from "./Content.vue";

export default {
  components: {
    DashboardContent,
  },
  data() {
    return {
      user_email: "",
      drawer: true,
      primaryNav: [
        { to: "/dashboard", label: "Dashboard", icon: "mdi-view-dashboard-outline" },
        { to: "/webscrapingapi", label: "Web Scraping API", icon: "mdi-web" },
        { to: "/mcp", label: "Web MCP", image: "/mcp.svg" },
        { to: "/residential", label: "Residential Proxies", icon: "mdi-account-network-outline" },
        { to: "/datacenter", label: "Datacenter Proxies", icon: "mdi-server-network" },
        { to: "/subscriptions", label: "Subscriptions", icon: "mdi-package-variant-closed" },
        { to: "/transactions", label: "Transactions", icon: "mdi-receipt-text-outline" },
        { to: "/whitelist", label: "IP Whitelist", icon: "mdi-shield-lock-outline" },
      ],
    };
  },
  computed: {
    avatarInitial() {
      if (!this.user_email) return "?";
      return this.user_email.charAt(0).toUpperCase();
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(null, console.log);
    },
    open_documentation() {
      window.open("https://docs.scrapingant.com/", "_blank");
    },
    open_proxies_documentation() {
      window.open("https://proxydocs.scrapingant.com/", "_blank");
    },
  },
  mounted() {
    this.$store.dispatch("auth/get_user").then((res) => {
      this.user_email = res.data.email;
      window.intercomSettings = window.intercomSettings || {};
      window.intercomSettings.email = this.user_email;
      if (window.Intercom) {
        window.Intercom("update", window.intercomSettings);
      }
    }, console.log);
  },
};
</script>

<style scoped lang="scss">
.dashboard-root {
  position: relative;
}

.app-sidebar {
  background-color: #0f172a !important;
  color: #ffffff;
  border-right: none !important;

  ::v-deep .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
  }

  &__brand {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px 20px 16px;
  }

  &__logo {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  &__wordmark {
    font-size: 17px;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: -0.01em;
  }

  &__list {
    padding: 8px 12px !important;
    background: transparent !important;

    ::v-deep .v-list-item {
      border-radius: 8px;
      min-height: 42px;
      padding: 0 12px !important;
      margin-bottom: 2px;
      color: rgba(255, 255, 255, 0.72);

      &:hover {
        background-color: rgba(255, 255, 255, 0.06);
        color: #ffffff;
      }

      &:before {
        opacity: 0 !important;
      }
    }

    ::v-deep .v-list-item--active {
      background-color: rgba(226, 120, 47, 0.14) !important;
      color: #ffffff !important;

      .v-list-item__title {
        color: #ffffff !important;
        font-weight: 600;
      }

      .v-icon,
      img {
        color: #e2782f !important;
        opacity: 1 !important;
      }
    }

    ::v-deep .v-list-item__title {
      color: rgba(255, 255, 255, 0.78);
      font-size: 14px;
      font-weight: 500;
    }

    ::v-deep .v-list-item__icon {
      margin-right: 12px !important;
      margin-top: 11px !important;
      margin-bottom: 11px !important;

      .v-icon {
        color: rgba(255, 255, 255, 0.55);
        font-size: 20px;
      }

      img {
        filter: brightness(0) invert(1);
        opacity: 0.55;
      }
    }
  }

  &__footer {
    margin-top: auto;
    padding-bottom: 12px;
  }

  &__divider {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.06);
    margin: 8px 20px 8px;
  }

  &__user {
    display: flex;
    align-items: center;
    gap: 10px;
    width: calc(100% - 24px);
    margin: 0 12px;
    padding: 10px 12px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    transition: background-color 120ms ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.06);
    }

    &:focus-visible {
      outline: 2px solid #e2782f;
      outline-offset: 2px;
    }
  }

  &__user-initial {
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
  }

  &__user-email {
    flex: 1;
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.82);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__user-chevron {
    color: rgba(255, 255, 255, 0.55) !important;
  }

  &__menu {
    border-radius: 10px;
    padding: 6px 0 !important;
  }
}

.app-topbar-mobile {
  border-bottom: 1px solid rgba(15, 23, 42, 0.08) !important;

  ::v-deep .v-toolbar__content {
    padding: 0 12px;
  }

  &__brand {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 4px;

    img {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }

    span {
      font-size: 15px;
      font-weight: 600;
      color: #0f172a;
      letter-spacing: -0.01em;
    }
  }
}
</style>
